import styled from 'styled-components';
import {Button, Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledVendorPaymentsList = styled.div`
  .ant-btn-link {
    color: ${props => props.theme.colors.primary_7};
    padding: 0;
  }
`;

const StyledVendorPaymentsListTitle = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.neutral_7};
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  width: 100%;
`;

const StyledVendorPaymentsListSpace = styled(Space)`
  padding-top: 8px;
  width: 100%;
`;

const StyledVendorPaymentsListItem = styled.div`
  ${typographyStyles.footnote.description};
  
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const StyledVendorPaymentsListItemDate = styled.span`
  color: ${props => props.theme.colors.neutral_8};
  font-size: 12px;
`;

const StyledVendorPaymentsListItemSource = styled.span`
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledVendorPaymentsListItemPriceSpace = styled(Space)`
  color: ${props => props.theme.colors.functional_danger};
  font-size: 12px;
  font-weight: 500;
  width: unset !important;
  
  .empty {
    margin-right: 32px;
  }
`;

const StyledVendorPaymentsListItemIconButton = styled(Button)`
  align-items: center;
  display: flex;
  justify-content: center;
  
  svg {
    height: 20px;
    width: 20px;
    
    path {
      fill: ${props => props.theme.colors.primary_7};
      transition: .2s ease;
    }
  }
`

export {
  StyledVendorPaymentsList,
  StyledVendorPaymentsListTitle,
  StyledVendorPaymentsListSpace,
  StyledVendorPaymentsListItem,
  StyledVendorPaymentsListItemDate,
  StyledVendorPaymentsListItemSource,
  StyledVendorPaymentsListItemPriceSpace,
  StyledVendorPaymentsListItemIconButton
};
